// import './../action/Grade.action'
import { Grade_LIST } from '../type/Grade.type';

const defaultData = {
	gradeList: []
};

const Grade = (state = defaultData, action) => {
	let copyState = { ...state };
	switch (action.type) {
		case Grade_LIST:
			copyState.gradeList = action.res;
			return copyState;
		default:
			return copyState;
	}
};
export default Grade;



// WEBPACK FOOTER //
// ./src/redux/reducer/Grade.reducer.js